import script from "./UrlCompareForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UrlCompareForm.vue?vue&type=script&setup=true&lang=js"

import "./UrlCompareForm.vue?vue&type=style&index=0&id=8151958c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8151958c"]])

export default __exports__